(() => {

  'use strict';

  // GSAP確認
  if (typeof gsap === 'undefined') {
    console.warn('GSAP is not loaded. Please include GSAP library.');
    return;
  }

  // mix関数
  function mix(x, y, a) {
    return x * (1 - a) + y * a;
  }

  // clip-pathの設定値
  const clipPathRate = 0.85;
  const clipPathTop = 85;
  const clipPathBottom = 76;
  const clipPathEnd = 101;

  // インターバルIDを保持する変数
  let slideInterval = null;
  let timeline = null;

  const initTopKv = () => {
    // 既存のインターバルをクリア
    if (slideInterval !== null) {
      clearInterval(slideInterval);
      slideInterval = null;
    }

    // 既存のアニメーションをクリア
    if (timeline) {
      timeline.kill();
      timeline = null;
    }

    const list = document.querySelector('.sopoa-hero__list');
    if (!list) return;

    // 切り替え秒数
    const intervalS = parseFloat(list.getAttribute('data-slide-interval')) || 3;
    const intervalMS = intervalS * 1000;

    const items = list.querySelectorAll('.sopoa-hero__item');
    if (items.length === 0) return;

    const target = list.querySelectorAll('.sopoa-hero__img');

    // すべてのcurrentとprevクラスを削除
    items.forEach((img) => {
      img.classList.remove('current', 'prev');
    });

    // アニメーション関数
    const animation = (current, prev) => {
      if (timeline) {
        timeline.kill();
      }
      timeline = gsap.timeline();

      const currentTarget = target[current];
      const prevTarget = target[prev];

      // clip-pathのアニメーション値を管理するオブジェクト
      const clipPathValue = {
        value: 0
      };

      timeline.set(clipPathValue, {
        value: 0
      });
      timeline.set(items[current], {
        clipPath: 'polygon(0 0, 0 0, 0 100%, 0% 100%)'
      });

      timeline.add('01')
        .to(clipPathValue, {
          duration: 2,
          value: 1,
          ease: 'expo.out',
          onUpdate: function() {
            const value = clipPathValue.value;
            let clipPath;
            if (value > clipPathRate) {
              const normalizedValue = (value - clipPathRate) / (1 - clipPathRate);
              clipPath = `polygon(0 0, ${mix(clipPathTop, clipPathEnd, normalizedValue)}% 0, ${mix(clipPathBottom, clipPathEnd, normalizedValue)}% 100%, 0% 100%)`;
            } else {
              const normalizedValue = value / clipPathRate;
              clipPath = `polygon(0 0, ${normalizedValue * clipPathTop}% 0, ${normalizedValue * clipPathBottom}% 100%, 0% 100%)`;
            }
            gsap.set(items[current], {
              clipPath: clipPath
            });
          },
          onComplete: function() {
            gsap.set(items[current], {
              clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)'
            });
          }
        }, '01');
    };

    // 最初の画像をcurrentに設定
    let currentIndex = 0;
    items[currentIndex].classList.add('current');

    // 最後の画像をprevに設定（画像が2つ以上ある場合のみ）
    let prevIndex = 0;
    if (items.length > 1) {
      prevIndex = items.length - 1;
      items[prevIndex].classList.add('prev');
      gsap.set(items[prevIndex], {
        clearProps: 'clipPath'
      });
    }

    // 初期アニメーション実行
    if (items.length > 1) {
      animation(currentIndex, prevIndex);
    }

    // 3秒ごとに次の画像に切り替え
    const switchImage = () => {
      // 以前のprevクラスをすべて削除
      items.forEach((img) => {
        img.classList.remove('prev');
      });
      
      // 現在のcurrentクラスをprevに変更
      const prev = currentIndex;
      items[prev].classList.remove('current');
      items[prev].classList.add('prev');
      gsap.set(items[prev], {
        clearProps: 'clipPath'
      });
      
      // 次のインデックスに移動（最後の場合は最初に戻る）
      currentIndex = (currentIndex + 1) % items.length;
      
      // 新しいcurrentクラスを追加
      items[currentIndex].classList.remove('prev');
      items[currentIndex].classList.add('current');

      // アニメーション実行
      animation(currentIndex, prev);
    };

    // 設定された秒数ごとに切り替え（画像が2つ以上ある場合のみ）
    if (items.length > 1) {
      slideInterval = setInterval(switchImage, intervalMS);
    }

    // パララックス効果の設定
    const handleParallax = () => {
      items.forEach((img) => {
        const inner = img.querySelector('.sopoa-hero__img');
        if (!inner) return;

        const rect = img.getBoundingClientRect();
        const scrollY = window.scrollY || window.pageYOffset;
        const imgTop = rect.top + scrollY;
        const windowHeight = window.innerHeight;
        const imgHeight = rect.height;

        // ビューポート内に入っている場合のみパララックス効果を適用
        if (rect.bottom >= 0 && rect.top <= windowHeight) {
          const scrollProgress = (scrollY + windowHeight - imgTop) / (windowHeight + imgHeight);
          const translateY = (scrollProgress - 0.5) * 50;
          const scale = 1 + (scrollProgress - 0.5) * 0.1;

          inner.style.transform = `translate3d(0, ${translateY}px, 0) scale(${scale})`;
        }
      });
    };

  };

  // 初期化処理
  const init = () => {
    initTopKv();
  };

  // DOMContentLoadedで初期化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopifyのセクション再読み込みに対応
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      if (event.detail.sectionId && document.querySelector(`[data-section-id="${event.detail.sectionId}"] .sopoa-hero__list`)) {
        init();
      }
    });
  }

})();
